<div
  *ngIf="screenSize === screenSizeEnums.LargeScreen || (steps.length <= 1 && screenSize !== screenSizeEnums.SmallScreen)"
  class="carousel-footer-container">
  <button *ngIf="startButtonText" class="orange-btn" (click)="handleStartClick()">{{ startButtonText }}</button>
  <ng-container *ngIf="otherOptions">
    <div *ngFor="let option of otherOptions" class="other-options-container">
      <div class="option-header">{{ option.buttonHeader }}</div>
      <button class="orange-btn" (click)="handleOtherOptionClick(option.action)">{{ option.buttonText }}</button>
    </div>
  </ng-container>
</div>
<div *ngIf="screenSize !== screenSizeEnums.LargeScreen && steps.length > 1" class="carousel-footer-container">
  <div *ngIf="currentSlideIndex != 0" class="footer-column previous" (click)="handlePreviousClick($event)">
    <mat-icon>keyboard_arrow_left</mat-icon>
    <span>{{ previousButtonText }}</span>
  </div>
  <div *ngIf="currentSlideIndex === 0" class="footer-column previous">
    <mat-icon></mat-icon>
    <span></span>
  </div>
  <div class="footer-column">
    <div *ngIf="showIndicators" class="circle-bar center-content">
      <span #circleBar *ngFor="let step of steps" class="carousel-circle"></span>
    </div>
  </div>
  <div *ngIf="currentSlideIndex != steps.length - 1" class="footer-column next" (click)="handleNextClick($event)">
    <span>{{ nextButtonText }}</span>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
  <div *ngIf="currentSlideIndex === steps.length - 1 && startButtonText" class="footer-column next">
    <button class="orange-btn move-right" (click)="handleStartClick()">{{ startButtonText }}</button>
  </div>
</div>
